




















































import {
  doesValidationHaveError,
  FixerBase,
  fixerFormManager,
  FixerFormParams,
  FixerNameValue,
  FixerValidationEvent,
  useLoadJobValidationApi
} from '@/module/api/load-job/validation';
import { defineComponent, reactive, toRefs } from '@vue/composition-api';
import Vue from 'vue';

const {
  selectedItem: selectedValidation,
  selectItem: selectValidation,
  getItem: getValidation,
  isLoading: isValidationLoading,
  isFixInProgress
} = useLoadJobValidationApi();

const emptyState = () => {
  return {
    dialog: false,
    isValidForm: false,
    isLoading: false
  };
};
const state = reactive(emptyState());

const formData = reactive({});

const reset = () => {
  Object.assign(state, emptyState());
};

const initializeData = async (params: { validationUuid: string; jobUuid: string }) => {
  if (!params.validationUuid || !params.jobUuid) {
    const errMessage = 'Cannot select validation without a validation uuid';
    Vue.$log.error(errMessage);
    return;
  }
  Vue.$log.debug('FixerFormUserFitnessStatusSetToFit.initializeData');
  await selectValidation(params.validationUuid);
  if (selectedValidation.value?.uuid !== params.validationUuid) {
    await getValidation({ validationUuid: params.validationUuid, jobUuid: params.jobUuid });
    await selectValidation(params.validationUuid);
  }
};

const getCurrentStatus = () => {
  // Try to extract current status from validation message or refs
  if (selectedValidation.value?.validatorParams?.currentFitnessStatus) {
    return selectedValidation.value.validatorParams.currentFitnessStatus;
  }
  return 'MIGRATED/IN_PROGRESS/SCHEDULED';
};

export class FixerFormUserFitnessStatusSetToFitClass implements FixerBase {
  getName(): FixerNameValue {
    return FixerNameValue.USERFITNESSSTATUSSETTOFIT;
  }

  async showForm(params: FixerFormParams): Promise<void> {
    initializeData(params);
    state.dialog = true;
  }

  async hideForm(): Promise<void> {
    reset();
  }

  getValidationEvent(): FixerValidationEvent {
    const validationEvent: FixerValidationEvent = {
      name: this.getName(),
      userInputParams: {
        params: {}
      }
    };
    return validationEvent;
  }
}

export default defineComponent({
  name: 'FixerFormUserFitnessStatusSetToFit',
  emits: ['form:submit:validation'],
  props: ['validationUuid'],
  setup(props, context) {
    const fixer = new FixerFormUserFitnessStatusSetToFitClass();
    fixerFormManager.add(fixer);

    const emitSubmitForm = () => {
      context.emit('form:submit:validation', fixer.getValidationEvent());
    };

    return {
      ...toRefs(state),
      emitSubmitForm,
      selectedValidation,
      isValidationLoading,
      doesValidationHaveError,
      isFixInProgress,
      formData,
      getCurrentStatus
    };
  }
});
